<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.fechamentoFaaMassa"
        ref="RkmDataTable"
        sort-by="faaNumero"
        search-by="unidadeNomeFantasia"
    />
</template>

<script>
// Mixins.
import { data, error, formats, object, repository } from '@/mixins'

export default {
    created() {
        this.repositories = {
            fechamentoFaaMassa: this.getConectaSusRepository('prontoAtendimento.fechamentoFaaMassa'),
        }
    },
    data: () => ({
        fields: [
            { name: 'cadastro_unidade.nome_fantasia', key: 'unidadeNomeFantasia', label: 'Unidade', searchable: true, sortable: true },
            { name: 'cadastro_infraestrutura.nome', key: 'infraestruturaNome', label: 'Local de atendimento', searchable: true, sortable: true },
            { name: 'cadastro_setor.nome', key: 'setorNome', label: 'Setor', searchable: true, sortable: true },
            { name: 'pronto_atendimento_faa.numero', key: 'faaNumero', label: 'FAA', searchable: true, sortable: true },
            { name: 'pronto_atendimento_faa.created_at', key: 'dataAtendimento', label: 'Data de atendimento', searchable: true, sortable: true },
            { name: 'cadastro_cidadao.nome', key: 'pacienteNome', label: 'Paciente', searchable: true, sortable: true },
        ],
    }),
    methods: {
        refresh() {
            this.$refs.RkmDataTable.refresh()
        },
    },
    mixins: [data, error, formats, object, repository],
}
</script>